"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _default = function _default(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({}, props, {
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet",
    height: "10",
    width: "10",
    viewBox: "0 0 40 40",
    style: {
      verticalAlign: 'top',
      fill: 'currentcolor'
    }
  }), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "m23.3 20l-13.1-13.6c-0.3-0.3-0.3-0.9 0-1.2l2.4-2.4c0.3-0.3 0.9-0.4 1.2-0.1l16 16.7c0.1 0.1 0.2 0.4 0.2 0.6s-0.1 0.5-0.2 0.6l-16 16.7c-0.3 0.3-0.9 0.3-1.2 0l-2.4-2.5c-0.3-0.3-0.3-0.9 0-1.2z"
  })));
};

exports.default = _default;